/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptRecommendationBatchResponse {
    getFixupPrototypeFunction() { return PromptRecommendationBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<PromptRecommendationBatchResponse>): PromptRecommendationBatchResponse {
        let obj = Object.assign(new PromptRecommendationBatchResponse(), model);
        PromptRecommendationBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptRecommendationBatchResponse>): PromptRecommendationBatchResponse {
        if (!model) return null;
        return PromptRecommendationBatchResponse.newInstance(<PromptRecommendationBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptRecommendationBatchResponse) {
        if (!obj) return;

        models.PromptRecommendationBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptRecommendationBatchResponse): boolean {
        Object.setPrototypeOf(obj, PromptRecommendationBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.PromptRecommendationDetailItem.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.PromptRecommendationDetailItem; };

}
